<template>
  <div class="product">
    <section class="hd">
      <img :src="require(is1920 ? '../assets/product.png' : '../assets/product2880.png')"/>
    </section>
    <section class="bd">
      <div class="one">
        <img :src="require(is1920 ? '../assets/product01.png' : '../assets/product28801.png')"/>
        <div>
          <div>
            <p>国恒充电智慧交流充电桩</p>
            <p>GHJ220032B-3/4G</p>
          </div>
          <div>
            <p>外观尺寸  260mm*260mm*99mm</p>
            <p>输入电压  176V～264V AC</p>
            <p>额定功率  7kW</p>
            <p>充电接口  七孔充电枪1</p>
            <p>IP等   级   IP55</p>
          </div>
          <div style="margin-top:.3rem;">
            <p style="cursor: auto;font-size: .32rem;line-height: .40rem;">简约 时尚 智能 有序充电</p>
            <p @click="$router.push({name: 'productPile1'})">查看详情&nbsp;&nbsp;
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-arrow-right"></use>
            </svg>
            </p>
          </div>
        </div>
      </div>
      <div>
        <img :src="require(is1920 ? '../assets/product02.png' : '../assets/product28802.png')"/>
        <div>
          <div>
            <p>国恒充电智慧交流充电桩</p>
            <p>HD-AC7MP200</p>
          </div>
          <div>
            <p>外观尺寸  455mm*260mm*119mm</p>
            <p>输入电压  176V～264V AC</p>
            <p>额定功率  7kW</p>
            <p>充电接口  七孔充电枪1</p>
            <p>IP等   级   IP54</p>
          </div>
          <div>
            <p @click="$router.push({name: 'productPile'})">查看详情&nbsp;&nbsp;
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-arrow-right"></use>
            </svg>
            </p>
          </div>
        </div>
      </div>
      <div>
        <img :src="require(is1920 ? '../assets/product03.png' : '../assets/product28803.png')"/>
        <div>
          <div>
            <p>星络智慧交流充电盒</p>
            <p>HD-AC7MS100</p>
          </div>
          <div>
            <p>外观尺寸  500mm*210mm*111.5mm </p>
            <p>输入电压  187～253V AC</p>
            <p>额定功率  7kW</p>
            <p>充电接口  16A三孔插座1、32A七孔插座1</p>
            <p>IP等   级   IP32</p>
          </div>
          <div>
            <p @click="$router.push({name: 'productBox'})">查看详情&nbsp;&nbsp;
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-arrow-right"></use>
            </svg>
            </p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'product',
  inject: ['is1920']
}
</script>
<style lang="less">
.product{
  img{
    width: 100%;
    height: 100%;
  }
  .hd{
    width: 100%;
    min-width: 10rem;
    height: 6rem;
  }
  .bd{
    width: 12rem;
    margin: .8rem auto 0;
    >div{
      position: relative;
      height: 4.5rem;
      margin-bottom: .20rem;
      &.one{
        height: 4.8rem;
      }
      >div{
        position: absolute;
        top: .78rem;
        left: 1.3rem;
        >div{
          text-align: left;
          svg{
            font-size: .20rem;
          }
          &:nth-child(1){
            color: #000;
            p:first-child{
              font-size: .32rem;
              line-height: .40rem;
            }
            p:last-child{
              font-size: .24rem;
              line-height: .40rem;
            }
          }
          &:nth-child(2){
            margin-top: .05rem;
            color: #000;
            font-size: .20rem;
            line-height: .40rem;
          }
          &:nth-child(3){
            color: #13E4E8;
            margin-top: .15rem;
            p{
              font-size: .24rem;
              line-height: .40rem;
              cursor: pointer;
            }
          }
        }
      }
    }
  }
}
</style>
